import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { PopupContent } from '../popup/interfaces';
import { ZoneConnectionService } from '../../../services/authentication/zone-connection.service';
import { ApplicationMode, ZoneConnectionsService } from '../../../services/authentication/zone-connections.service';
import { map, switchMap } from 'rxjs/operators';
import { ConnectionType } from '@service/vo/remote/remote-objects';
import { ExternalApplicationInfo } from '../../../services/data/vo/remote/remote-objects';
import { BehaviorSubject, pipe } from 'rxjs';
import { PopupService } from '../../../services/app/popup.service';

@Component({
  selector: 'tun-remote-popup',
  templateUrl: './remote-popup.component.html',
  styleUrls: ['./remote-popup.component.scss']
})
export class RemotePopupComponent implements OnInit, PopupContent {

  @Input() public connectedElementRef: ElementRef;

  get showRemotePlayer$(){
    return this.zoneConnectionsService.applicationMode$
      .pipe(map(applicationMode => applicationMode == ApplicationMode.remoteMode))
  }

  get remotePlayerActive$(){
    return this.zoneConnectionsService.currentPlayerApplicationInfo$
    .pipe(
      map(remoteApplicationInfos => remoteApplicationInfos != null)
    )
  }


  public get remotePlayerApplicationInfo$(){
    return this.zoneConnectionsService.currentPlayerApplicationInfo$
  }

  public get lastPlayerApplicationInfo$(){
    return this.zoneConnectionsService.lastPlayerApplicationInfo$;
  }

  public get remoteRemoteApplicationInfos$(){
    return this.zoneConnectionsService.currentRemoteApplicationInfos$;
  }

  constructor(
    public elementRef: ElementRef,
    private zoneConnectionsService: ZoneConnectionsService,
    private popupService: PopupService
  ) { }

  ngOnInit(): void {
  }

  public stopConnect(){
    this.zoneConnectionsService.deactivateCurrentZoneConnection();
  }

  public close(){
    this.popupService.hidePopup$.next(this.connectedElementRef);
  }

}
